<template>
  <div>
    <!-- street nb | street | address second -->
    <b-row class="mb-5 mb-sm-4">
      <b-col cols="10" sm="8" md="5">
        <label>Address</label>
        <b-input :value="contact.address" @input="updateContact('address', $event)" />
      </b-col>
      <b-col cols="10" sm="8" md="4">
        <label>Complément</label>
        <b-input :value="contact.complement" @input="updateContact('complement', $event)" />
      </b-col>

      <b-col cols="5" sm="5" md="3">
        <label>Code postal</label>
        <b-input :value="contact.zipcode" @input="updateContact('zipcode', $event)" />
      </b-col>
    </b-row>
    <!-- zipcode | city | country -->
    <b-row>
      <b-col cols="10" sm="8" md="5">
        <label>Ville</label>
        <b-input :value="contact.city" @input="updateContact('city', $event)" />
      </b-col>
      <b-col cols="10" sm="8" md="4">
        <label>Pays</label>
        <b-form-select
          :value="contact.country"
          :options="countryOptions"
          @input="updateContact('country', $event)"
        >
          <template #first>
            <b-form-select-option :value="''" disabled>Choisissez le pays</b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
      <b-col cols="5" sm="5" md="3">
        <label>Complement 2</label>
        <b-input :value="contact.complement2" @input="updateContact('complement2', $event)" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    contact: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    allCountries() {
      return this.$store.getters.getCountries;
    },
    countryOptions() {
      let result = [];
      this.allCountries.forEach(element => {
        result.push({
          value: element.countryCode,
          text: element.countryName,
        });
      });
      return result;
    },
  },
  methods: {
    updateContact(key, value) {
      this.$emit("updateContact", key, value);
    },
  },
};
</script>
